import {
    TOUR_DISCOUNT_CAMPAIGNS_CREATE_START,
    TOUR_DISCOUNT_CAMPAIGNS_CREATE_SUCCESS,
    TOUR_DISCOUNT_CAMPAIGNS_CREATE_ERROR,
    TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_START,
    TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_SUCCESS,
    TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_ERROR,
    TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_START,
    TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_SUCCESS,
    TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_ERROR,
    TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_START,
    TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_SUCCESS,
    TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_ERROR,
    DISCOUNT_SCHEDULE_CAMPAIGNS_LIVE_FILTER_SUCCESS,
    DISCOUNT_SCHEDULE_CAMPAIGNS_SCHEDULE_FILTER_SUCCESS
} from "../Constants/TourCampaignConstants";

const initialState = {
    loading: false,
    tourCampaignCreateData: [],
    tourAllCampaignsList: [],
    tourLiveCampaignsList: [],
    tourScheduledCampaignsList: [],
    discountLiveFilterdetail: [],
    discountLiveShaduleFilterdetail: [],
}

export default function TourCampaignReducers(
    state = { ...initialState},
    action
) {
    switch (action.type) {
        case TOUR_DISCOUNT_CAMPAIGNS_CREATE_START:
           return {
               ...state,
               loading: true,
           };
           case TOUR_DISCOUNT_CAMPAIGNS_CREATE_SUCCESS:
           return {
               ...state,
               tourCampaignCreateData: action.payload,
               loading: false,
           };
           case TOUR_DISCOUNT_CAMPAIGNS_CREATE_ERROR:
               return {
                   ...state,
                   loading: false,
                   message: action.error.message,
               };

               case TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_START:
                return {
                    ...state,
                    loading: true,
                };
                case TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_SUCCESS:
                return {
                    ...state,
                    tourAllCampaignsList: action.payload,
                    loading: false,
                };
                case TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_ERROR:
                    return {
                        ...state,
                        loading: false,
                        message: action.error.message,
                    };


               case TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_START:
                return {
                    ...state,
                    loading: true,
                };
                case TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_SUCCESS:
                return {
                    ...state,
                    tourLiveCampaignsList: action.payload,
                    loading: false,
                };
                case TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_ERROR:
                    return {
                        ...state,
                        loading: false,
                        message: action.error.message,
                    };


               case TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_START:
                return {
                    ...state,
                    loading: true,
                };
                case TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_SUCCESS:
                return {
                    ...state,
                    tourScheduledCampaignsList: action.payload,
                    loading: false,
                };
                case TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_ERROR:
                    return {
                        ...state,
                        loading: false,
                        message: action.error.message,
                    };

                    case DISCOUNT_SCHEDULE_CAMPAIGNS_LIVE_FILTER_SUCCESS:
                        return {
                            ...state,
                            discountLiveFilterdetail: action.payload,
                            loading: false,
                        };
                        case DISCOUNT_SCHEDULE_CAMPAIGNS_SCHEDULE_FILTER_SUCCESS:
                        return {
                            ...state,
                            discountLiveShaduleFilterdetail: action.payload,
                            loading: false,
                        };

               default:
                   return state;
    }
}